import React from 'react';
import LeaveManagementCreate from '../LeaveManagement/LeaveManagementCreate';

interface CreateLeaveRequestProps {}

const CreateLeaveRequest: React.FC<CreateLeaveRequestProps> = () => {
  return <LeaveManagementCreate />;
};

export default CreateLeaveRequest;